(function () {
  'use strict';

  console.log('[pdp-linked-swatches] script loaded');

  /* ---------------------------------------------------------------------
     Colour swatches: full page load, not an AJAX swap

     Linked colours are separate products. The Notify Me app resolves its product
     once per page load and its widget keeps a private copy of it, so it cannot be
     re-pointed at another product without a reload - swapping over AJAX leaves the
     notify form listing the PREVIOUS colour's sizes. The same applies to any app
     that reads product data at render time.

     So colour changes navigate normally for now. Scroll position is carried across,
     since the swatches sit well down the page and a fresh navigation would otherwise
     dump the shopper back at the top.

     The AJAX path below is left intact: set USE_AJAX_SWAP back to true to restore it
     once the app supports a product change without a reload.
     --------------------------------------------------------------------- */
  var USE_AJAX_SWAP = false;
  var SCROLL_KEY = 'pdpLinkedSwatchScroll';

  var pendingFetch = null;

  function saveScroll() {
    try {
      sessionStorage.setItem(SCROLL_KEY, String(window.scrollY));
    } catch (err) { /* private mode / storage blocked - just lose the position */ }
  }

  function restoreScroll() {
    var saved = null;
    try {
      saved = sessionStorage.getItem(SCROLL_KEY);
      sessionStorage.removeItem(SCROLL_KEY);
    } catch (err) {
      return;
    }

    var y = parseInt(saved, 10);
    if (!y) return;

    window.scrollTo(0, y);

    // Images and app widgets finish later and can move the target, so set it once
    // more on load - unless the shopper has already started scrolling themselves.
    var userMoved = false;
    ['wheel', 'touchstart', 'keydown'].forEach(function (evt) {
      window.addEventListener(evt, function () { userMoved = true; }, { once: true, passive: true });
    });

    window.addEventListener('load', function () {
      if (!userMoved) window.scrollTo(0, y);
    }, { once: true });
  }

  function getSectionId() {
    var el = document.querySelector('[data-wetheme-section-type="template--product"][data-wetheme-section-id]');
    if (!el) { console.warn('[pdp-linked-swatches] no product section element found'); return null; }
    return el.dataset.wethemeSectionId;
  }

  function sortSwatches() {
    var wrapper = document.querySelector('.pdp-linked-products-swatch .swatch-items-wrapper');
    if (!wrapper) return;
    var items = Array.from(wrapper.querySelectorAll('.swatch-element'));
    items.sort(function (a, b) {
      var aLabel = (a.querySelector('a') || {getAttribute: function(){return '';}}).getAttribute('aria-label') || '';
      var bLabel = (b.querySelector('a') || {getAttribute: function(){return '';}}).getAttribute('aria-label') || '';
      return aLabel.localeCompare(bLabel);
    });
    items.forEach(function (el) { wrapper.appendChild(el); });
  }

  function swapSections(doc) {
    var newMedia = doc.querySelector('[data-product-media-wrapper]');
    var curMedia = document.querySelector('[data-product-media-wrapper]');
    console.log('[pdp-linked-swatches] media swap:', !!newMedia, !!curMedia);
    if (newMedia && curMedia) curMedia.replaceWith(newMedia);

    var swapped = 0;
    doc.querySelectorAll('[data-update-id]').forEach(function (newEl) {
      var id = newEl.dataset.updateId;
      var curEl = document.querySelector('[data-update-id="' + id + '"]');
      if (curEl) { curEl.replaceWith(newEl); swapped++; }
    });
    console.log('[pdp-linked-swatches] update-id blocks swapped:', swapped);
  }

  function handleSwatchClick(e) {
    // Never intercept clicks that happen inside the cross-sell modal — those are
    // handled by cross-sell-quick-view.js and must not affect the background page.
    if (e.target.closest('.cross-sell-modal-pdp')) return;

    var link = e.target.closest('a.pdp-linked-swatch__link');
    if (!link) return;

    if (link.getAttribute('aria-current') === 'page') {
      e.preventDefault();
      return;
    }

    var href = link.getAttribute('href');
    if (!href) return;

    if (!USE_AJAX_SWAP) {
      // Let the browser navigate; just remember where we were on the page.
      saveScroll();
      return;
    }

    var sectionId = getSectionId();
    if (!sectionId) return;

    e.preventDefault();
    console.log('[pdp-linked-swatches] fetching', href, 'section', sectionId);

    document.querySelectorAll('.pdp-linked-products-swatch .swatch-element').forEach(function (el) {
      el.classList.remove('active');
    });
    link.closest('.swatch-element').classList.add('active');

    if (pendingFetch) pendingFetch.abort();
    var controller = new AbortController();
    pendingFetch = controller;

    fetch(href + '?section_id=' + encodeURIComponent(sectionId), { signal: controller.signal })
      .then(function (res) {
        console.log('[pdp-linked-swatches] fetch status:', res.status, 'length hint:', res.headers.get('content-length'));
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        console.log('[pdp-linked-swatches] html length:', html.length);
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        swapSections(doc);
        sortSwatches();
        history.pushState({ pdpLinked: href }, '', href);
      })
      .catch(function (err) {
        if (err.name === 'AbortError') return;
        console.error('[pdp-linked-swatches] error:', err);
        window.location.href = href;
      });
  }

  /* ---------------------------------------------------------------------
     Hover preview of the colour name

     The theme's own <product-swatch> does this for variant swatches
     (component-product-swatch.js), but linked colours are separate products
     rendered as plain anchors, so they get none of that behaviour. Mirror it
     here: hovering a swatch previews its colour name, leaving restores the
     selected one.
     --------------------------------------------------------------------- */
  function initColorNameHover() {
    var swatch = document.querySelector('.pdp-linked-products-swatch');
    if (!swatch) { console.warn('[pdp-linked-swatches] hover: no .pdp-linked-products-swatch'); return; }

    var wrapper = swatch.querySelector('.swatch-items-wrapper');
    // Fall back to the plain markup, so this works even on a theme that does not
    // yet have the data-color-swatch-name hooks in template--product.liquid.
    var labelContainer = swatch.querySelector('[data-color-swatch-name-container]')
      || swatch.querySelector('.product-swatch-color-name');
    var label = swatch.querySelector('[data-color-swatch-name]')
      || (labelContainer && labelContainer.querySelector('span'))
      || labelContainer;

    if (!wrapper || !label) {
      console.warn('[pdp-linked-swatches] hover: missing', { wrapper: !!wrapper, label: !!label });
      return;
    }

    var hovered = null;
    var currentLabel = label.textContent.trim();

    // data-value is set in the Liquid; aria-label on the anchor is the fallback.
    function valueOf(el) {
      if (!el) return '';
      var value = el.getAttribute('data-value');
      if (value) return value;
      var link = el.querySelector('a');
      return (link && link.getAttribute('aria-label')) || '';
    }

    function setLabel(value) {
      if (!value || value === currentLabel) return;
      label.textContent = value;
      currentLabel = value;
      if (!labelContainer) return;
      // Restart the theme's label animation (same approach as component-product-swatch.js).
      labelContainer.classList.remove('fade-in-label');
      void labelContainer.offsetWidth;
      labelContainer.classList.add('fade-in-label');
    }

    function preview(el) {
      setLabel(valueOf(el));

      // Drop the selected swatch's ring while previewing a different colour.
      var active = wrapper.querySelector('.swatch-element.active');
      if (active && active !== el) active.classList.add('sibling-hover-active');
    }

    function reset() {
      var active = wrapper.querySelector('.swatch-element.active');
      if (!active) return;
      active.classList.remove('sibling-hover-active');
      setLabel(valueOf(active));
    }

    // mouseenter/mouseleave do not bubble, so delegate with mouseover.
    // The gaps between swatches deliberately do NOT reset the label - otherwise it
    // flicks back to the selected colour every time the cursor crosses one.
    wrapper.addEventListener('mouseover', function (e) {
      var el = e.target.closest('.swatch-element');
      if (!el || !wrapper.contains(el) || el === hovered) return;
      hovered = el;
      preview(el);
    });

    wrapper.addEventListener('mouseleave', function () {
      if (!hovered) return;
      hovered = null;
      reset();
    });
  }

  document.addEventListener('click', handleSwatchClick);
  sortSwatches();
  initColorNameHover();
  restoreScroll();

  if (USE_AJAX_SWAP) {
    // pushState swaps leave a stale document on back/forward.
    window.addEventListener('popstate', function () {
      window.location.reload();
    });
  }
})();
